export default __webpack_public_path__ + "media/hot-now3x.98144005.png";